module.exports = __webpack_public_path__ + "img/check-red.5b29edbc.svg";